var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhyImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 39.617,
    viewBox: "0 0 33 39.617",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_09-timer",
    "data-name": "09-timer",
    transform: "translate(-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M36.5,11.788l2.371-2.371L36.533,7.083,34,9.619A16.4,16.4,0,0,0,26.15,6.682V3.3h3.3V0h-9.9V3.3h3.3V6.682A16.4,16.4,0,0,0,15,9.619L12.467,7.083,10.133,9.417,12.5,11.788a16.5,16.5,0,1,0,23.991,0ZM24.5,36.3A13.2,13.2,0,1,1,37.7,23.1,13.2,13.2,0,0,1,24.5,36.3Z",
    fill: "#4397d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M33.9,32v9.9H24A9.9,9.9,0,1,0,33.9,32Z",
    transform: "translate(-9.4 -18.8)",
    fill: "#4397d2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyImg1);
export default __webpack_public_path__ + "static/media/whyImg1.c1de675fd03c76e97726efbc5359135c.svg";
export { ForwardRef as ReactComponent };